















import { defineComponent, useRouter } from '@nuxtjs/composition-api';

import AMXButton from '~/components/AMXButton.vue';

interface NoResultsFoundEmitProps {
  emit: {
    (event: 'go-to-make'): void;
    (event: 'close-sidebar'): void;
  };
}

export default defineComponent({
  components: {
    AMXButton,
  },
  setup(_: unknown, { emit }: NoResultsFoundEmitProps) {
    const router = useRouter();

    const handleGoToMake = () => {
      emit('go-to-make');
    };

    const onContactClicked = () => {
      emit('close-sidebar');
      router.push('/pages/contact');
    };

    return {
      handleGoToMake,
      onContactClicked,
    };
  },
});
